import React from 'react';

const SvgTableDropdown = (props) => (
    <svg width={9} height={4} {...props} viewBox="0 0 9 4">
        <path d="M7.251 0H0l4.5 4L9 0z" fill={props.color || '#FFF'} fillRule="evenodd" />
    </svg>
);

export default SvgTableDropdown;
